import { Checkbox, MultiSelect, NumberInput, Select, Stack, TextInput } from '@mantine/core';
import type { CustomFieldValue, CustomFieldValues } from '@/api/customFields';
import type { FieldEntry } from './customFieldHelpers';

/** Eingabefelder für benutzerdefinierte Felder (CF-03, TEAM-06). */
export function CustomFieldInputs({
  fields,
  values,
  onChange,
  disabled,
  isAdmin,
}: {
  fields: FieldEntry[];
  values: CustomFieldValues;
  onChange: (values: CustomFieldValues) => void;
  disabled?: boolean;
  isAdmin?: boolean;
}) {
  const set = (id: string, value: CustomFieldValue) => onChange({ ...values, [id]: value });
  return (
    <Stack gap="xs">
      {fields.map(({ field }) => {
        const value = values[field.id];
        const locked = disabled || (field.adminOnly && !isAdmin);
        const common = { label: field.name, withAsterisk: field.required, disabled: locked, key: field.id };
        switch (field.type) {
          case 'NUMBER':
            return (
              <NumberInput
                {...common}
                value={typeof value === 'number' ? value : value ? Number(value) : ''}
                onChange={(v) => set(field.id, v === '' ? null : Number(v))}
                decimalSeparator=","
              />
            );
          case 'CHECKBOX':
            return <Checkbox {...common} checked={value === true} onChange={(e) => set(field.id, e.currentTarget.checked)} mt={4} />;
          case 'SELECT':
            return (
              <Select
                {...common}
                data={field.options}
                value={typeof value === 'string' ? value : null}
                onChange={(v) => set(field.id, v)}
                clearable
                searchable
              />
            );
          case 'MULTI_SELECT':
            return (
              <MultiSelect
                {...common}
                data={field.options}
                value={Array.isArray(value) ? value : []}
                onChange={(v) => set(field.id, v)}
                clearable
                searchable
              />
            );
          case 'LINK':
            return (
              <TextInput
                {...common}
                type="url"
                placeholder="https://"
                value={typeof value === 'string' ? value : ''}
                onChange={(e) => set(field.id, e.currentTarget.value)}
              />
            );
          default:
            return <TextInput {...common} value={value == null ? '' : String(value)} onChange={(e) => set(field.id, e.currentTarget.value)} />;
        }
      })}
    </Stack>
  );
}
